"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrder = void 0;

var _tslib = require("tslib");

var _context = require("../context");

var useOrder = function useOrder() {
  var dispatch = (0, _context.useOrderDispatch)();
  var state = (0, _context.useOrderState)();

  var setOrder = function setOrder(orderState) {
    dispatch({
      type: "SET"
      /* SET */
      ,
      payload: (0, _tslib.__assign)({}, orderState)
    });
  };

  var unsetOrder = function unsetOrder() {
    dispatch({
      type: "UNSET"
      /* UNSET */

    });
  };

  var removeOrderInfo = function removeOrderInfo() {
    dispatch({
      type: "REMOVE_ORDER_INFO"
      /* REMOVE_ORDER_INFO */

    });
  };

  var emptyOrder = function emptyOrder() {
    dispatch({
      type: "EMPTY"
      /* EMPTY */

    });
  };

  return {
    setOrder: setOrder,
    emptyOrder: emptyOrder,
    order: state,
    unsetOrder: unsetOrder,
    removeOrderInfo: removeOrderInfo,
    type: state.serviceMethod === 4 ? 'delivery' : 'pickup'
  };
};

exports.useOrder = useOrder;